import { render, staticRenderFns } from "./PopupDetail.vue?vue&type=template&id=831cdc34"
import script from "./PopupDetail.vue?vue&type=script&lang=js"
export * from "./PopupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports